import React from 'react';

import {
  StyledBeadcrumb,
  StyledBeadcrumbIcon,
  StyledBeadcrumbPrimary
} from './style';

import { Arrow } from '../../../../assets/images/index';

const TwoLevelBreadcrumb = ({ first, second, onBack, className }) => (
  <StyledBeadcrumb className={className}>
    <span
      className="primary"
      onClick={() => {
        onBack();
      }}
      onKeyUp={() => {}}
      role="button"
      tabIndex="0"
    >
      {first}
    </span>
    <StyledBeadcrumbIcon color="dark" size="m" svg={Arrow} />
    <StyledBeadcrumbPrimary>{second}</StyledBeadcrumbPrimary>
  </StyledBeadcrumb>
);

export default TwoLevelBreadcrumb;
